/**
 * Member slice — a player's page (DESIGN-CHANGELOG 2026-09-03 "A player's
 * page"; docs/porting/AA.md phase 5 §J; migration 3064).
 *
 * Read-only: `memK` is whose page is up, `memTab` is RATINGS (`'sc'`) or one
 * of their GOTY years (`'y2026'`). Their scores are already in `scores` (the
 * party's read, 3060); their GOTY lists come through `crew_goty`, cached per
 * key for the session and refetched on every open — a page about someone
 * else must not show yesterday's list.
 */

import type { StateCreator } from 'zustand';

import type { MemberGotyYear } from '../../repo/Repository.ts';
import type { QdStore } from '../types.ts';

export interface MemberSlice {
  memK: string;
  memTab: string;
  memGoty: Record<string, MemberGotyYear[]>;
  memBusy: boolean;
  /** Open the page on a crewmate and read their lists. */
  openMember: (k: string) => void;
  setMemTab: (t: string) => void;
}

export const createMemberSlice: StateCreator<QdStore, [], [], MemberSlice> = (set, get) => ({
  memK: '',
  memTab: 'sc',
  memGoty: {},
  memBusy: false,

  openMember: (k) => {
    const s = get();
    if (!s.user(k)) return;
    set({ memK: k, memTab: 'sc', memBusy: true });
    s.nav('member');
    void (async () => {
      try {
        const years = await get().repo.fetchMemberGoty(k);
        set((st) => ({ memGoty: { ...st.memGoty, [k]: years }, memBusy: false }));
      } catch {
        set({ memBusy: false });
      }
    })();
  },
  setMemTab: (t) => set({ memTab: t }),
});
